export function NotFoundPage() {
  return (
    <div className="mx-auto flex w-full max-w-md flex-1 flex-col items-center gap-4 pt-16 text-center sm:pt-24">
      <h1 className="font-serif text-2xl font-medium">Page not found</h1>
      <p className="text-sm text-muted-foreground">
        The page you&apos;re looking for doesn&apos;t exist. If you received a tracking link, please
        double-check the URL.
      </p>
    </div>
  );
}
